import { renderToStaticMarkup } from "react-dom/server";
import { Citation, CitationType, getCitationFilePath } from "../../api";

type HtmlParsedAnswer = {
    answerHtml: string;
    citations: string[];
};

// The bracket token is just a display name (e.g. 'lora-1.png'), not a blob path, so it can
// only be turned into a working /content/... URL via the citation's own metadata.
function resolveCitationPath(name: string, citation: Citation | undefined): string {
    if (citation?.type === CitationType.Sharepoint) {
        if (citation.metadata?.image_path) return getCitationFilePath(citation.metadata.image_path);
        if (citation.metadata?.sharepoint_uri) return citation.metadata.sharepoint_uri;
    }
    if (citation?.type === CitationType.Event && citation.metadata?.lorinlogs_uri) {
        return citation.metadata.lorinlogs_uri;
    }
    return getCitationFilePath(name);
}

export function parseAnswerToHtml(
    answer: string,
    isStreaming: boolean,
    onCitationClicked: (citationFilePath: string) => void,
    citationsByName: Map<string, Citation> = new Map()
): HtmlParsedAnswer {
    const citations: string[] = [];

    let parsedAnswer = answer.trim();

    // Omit a citation that is still being typed during streaming.
    // If we see an unclosed "[" (no matching "]" after it), truncate there.
    if (isStreaming) {
        const lastOpen = parsedAnswer.lastIndexOf("[");
        const lastClose = parsedAnswer.lastIndexOf("]");
        if (lastOpen !== -1 && lastOpen > lastClose) {
            parsedAnswer = parsedAnswer.substring(0, lastOpen);
        }
    }

    const parts = parsedAnswer.split(/\[([^\]]+)\]/g);

    const fragments: string[] = parts.map((part, index) => {
        if (index % 2 === 0) {
            return part;
        } else {
            let citationIndex: number;
            if (citations.indexOf(part) !== -1) {
                citationIndex = citations.indexOf(part) + 1;
            } else {
                citations.push(part);
                citationIndex = citations.length;
            }
            const path = resolveCitationPath(part, citationsByName.get(part));

            return renderToStaticMarkup(
                <a className="supContainer" title={part} onClick={() => onCitationClicked(path)}>
                    <sup>{citationIndex}</sup>
                </a>
            );
        }
    });
    return {
        answerHtml: fragments.join(""),
        citations
    };
}
